import { requirementLabel, type FulfillmentOrder } from '../../domain/fulfillment';

/** One row of a printed packing list: what is on the pallet. */
export interface PackingListRow {
  lineId: string;
  name: string;
  /** Packed so far: serials scanned, or stock quantity picked. */
  packed: number;
  ordered: number;
  /** Stock unit, e.g. "pcs"; blank for serialized lines. */
  unit: string;
  serials: string[];
}

export interface PackingListNames {
  part: (id: string) => string;
  stock: (id: string) => string;
  unit: (stockItemId: string | undefined) => string;
}

/** The order's lines as packing list rows, in order-line order. */
export function packingListRows(
  order: Pick<FulfillmentOrder, 'lines'>,
  names: PackingListNames,
): PackingListRow[] {
  return order.lines.map((line) => {
    const serialized = line.requirement.type === 'SERIALIZED';
    return {
      lineId: line.id,
      name: requirementLabel(line.requirement, { part: names.part, stock: names.stock }),
      packed: serialized ? line.itemIds.length : line.pickedQuantity,
      ordered: line.requirement.quantity,
      unit: serialized ? '' : names.unit(line.requirement.stockItemId),
      serials: serialized ? [...line.itemIds] : [],
    };
  });
}

/** Rows still short of what was ordered, for a warning on the sheet. */
export function shortRows(rows: PackingListRow[]): PackingListRow[] {
  return rows.filter((row) => row.packed < row.ordered);
}
